"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 10 16'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: 'currentColor',
    d: "M2.5,16 C1.12133333,16 8.8817842e-16,14.8786667 8.8817842e-16,13.5 L8.8817842e-16,2.5 C8.8817842e-16,1.12133333 1.12133333,0 2.5,0 L7.5,0 C8.87866667,0 10,1.12133333 10,2.5 L10,13.5 C10,14.8786667 8.87866667,16 7.5,16 L2.5,16 Z M1,13.5 C1,14.3273333 1.67266667,15 2.5,15 L7.5,15 C8.32733333,15 9,14.3273333 9,13.5 L9,13 L1,13 L1,13.5 Z M9,12 L9,2.5 C9,1.67266667 8.32733333,1 7.5,1 L2.5,1 C1.67266667,1 1,1.67266667 1,2.5 L1,12 L9,12 Z",
    id: "icon-phone"
  }));
});